import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return _withDirectives((_openBlock(), _createElementBlock("img", null, null, 512)), [
    [_directive_lazy, { src: __props.src }]
  ])
}
}

})